import { current } from '@reduxjs/toolkit';
import { UpdateOrderState } from '../type';

const removeItemFromMenu = (state: UpdateOrderState, menuItemId: string): UpdateOrderState => {
  const findIndex = current(state.updatedOrder?.orderItems || []).findIndex((x) => x.menuItemId === menuItemId);
  const find = current(state?.updatedOrder?.orderItems || [])[findIndex];
  if (find?.count === 1) {
    return {
      ...state,
      updatedOrder: {
        ...state?.updatedOrder,
        orderItems: current(state?.updatedOrder?.orderItems || []).filter((_, i) => i !== findIndex),
      },
    };
  }
  return {
    ...state,
    updatedOrder: {
      ...state?.updatedOrder,
      orderItems: current(state?.updatedOrder?.orderItems || []).map((item, index) => {
        if (index === findIndex) {
          return {
            ...item,
            count: (item?.count || 0) - 1,
            orderItemToppings: item?.toppings?.map((x) => ({
              ...x,
              count: (item.count || 0) - 1,
            })),
          };
        }
        return item;
      }),
    },
  };
};

export default removeItemFromMenu;
